// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"370":"b27c6ad0","7923":"b27c6ad0","8237":"b27c6ad0"}[chunkId] + ".chunk.css";
};